import React,{useEffect, useState} from 'react'
import EmployeeSchedule from './EmployeeSchedule';
import { CommonHeader } from '../../../components/commons';
import NewRequests from './NewRequests';
import ApprovedRequests from './ApprovedRequests';
import Calander from '../../../components/Scheduling/viewPages/Calander';
import ApprovedCalander from '../../../components/Scheduling/viewPages/ApprovedCalander';
import { useLocation } from 'react-router-dom';
type TabsType = {
  name: string;
  label: string;
}
const tabs: TabsType[] = [
  {
    name: "New Requests",
    label: "newRequests"
  },
  {
    name: "Approved Requests",
    label:"approvedRequests"
  },
  {
    name: "Employee Schedule",
    label:"employeeSchedule"
  }

]
type AppProps = {
  history:any
}
const ManagerView = ({history}:AppProps) => {
  const search = useLocation().search;
  const notificationRedirectActiveTab = new URLSearchParams(search).get('activeTab');
    const [activeTab, setActiveTab] = useState(tabs[0].label);
  const handleTabChange = (tabs:string) => {
  setActiveTab(tabs)
  }

let currentActiveTab=localStorage.getItem('currentTab')

  useEffect(()=>{
    if(currentActiveTab){
      setActiveTab(currentActiveTab)
    }
    localStorage.removeItem('currentTab')
  },[])

  // useEffect(()=>{
  //  if(notificationRedirectActiveTab==="newRequests"){
  //     setActiveTab("newRequests")
  //   }
  //   // if(notificationRedirectActiveTab==="approvedRequests"){
  //   //   setActiveTab("approvedRequests")
  //   // }
  //   // else 
  
  // },[notificationRedirectActiveTab])

   const renderTabs = () => {
    const finalTab = tabs?.map((tab: TabsType) => {
      return (
        <div key={tab?.label}
          className='pointer mr-2'
          onClick={() => { handleTabChange(tab?.label) }}
        >
          <div style={{ padding: "12px 5px 12px 5px", color: activeTab === tab?.label ? "#dd4433" : "", fontSize: "14px" }} className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}>
            {tab?.name}
          </div>
          <div
            className={`${activeTab === tab?.label
              ? "active-tab-bottom-border"
              : "not-active-tab-bottom-border"
              }`}
          ></div>
        </div>
      )
    })
    return finalTab
  }
  

   const activeTabRender=()=>{
    switch(activeTab){
      case "newRequests":
        return <NewRequests history={history}/>
      case "approvedRequests":
        return <ApprovedRequests history={history} activeTab={activeTab}/>
        case "employeeSchedule":
          return <ApprovedCalander/>
        }
  }
  return (
      <>
    <div className='row'>
      <div className='col-md-6'>
        <CommonHeader title='Estimate Approval Requests'/>
      </div>
    </div>
         <div className="col-md-12 mt-4">
                <div style={{ background: "#d8dee4", borderRadius: "5px 5px 0 0", padding: "0px 15px" }}>
                    <div className='d-flex'>{renderTabs()}</div>
                </div>
            </div>

            <div className='col-md-12'>
                <div style={{ border: "1px solid #bfcbe1", backgroundColor: "#fff" }} >
                    {activeTabRender()}
                </div>
            </div>
    </>
     
  )
}

export default ManagerView;
